import { managerActions } from '@store/reducers/manager/actions'
import { all, put } from 'redux-saga/effects'

import { InitProjectActions } from './initProjectActions'

export function* initProjectActionsSaga() {
  try {
    yield put({ type: managerActions.resetProject.type })
    yield all(InitProjectActions.map((action) => put(action)))
  } catch (error) {
    console.error('Error creating project boilerplate:', error)
  }
}
